<script setup lang="ts">
import { useAppConfig } from '#app/config';
import { useNuxtUiLocale } from '#layers/ui/composables/use-nuxt-ui-locale';

const appConfig = useAppConfig();
const nuxtUiLocale = useNuxtUiLocale();
</script>

<template>
	<DHoverCardProvider>
		<DApp :locale="nuxtUiLocale" :tooltip="appConfig.tooltip" :toaster="appConfig.toaster">
			<slot />
			<DHoverCardOutlet />
		</DApp>
	</DHoverCardProvider>
</template>
